export default __webpack_public_path__ + "static/media/Newsletter 018.e696ec79.png";